import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { FeatureFlags, FEATURE_FLAG_KEYS } from '../domain/feature-flags';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService extends ApiService {

  constructor(http: HttpClient) {
    super(http);
  }

  async getFeatureFlags(): Promise<FeatureFlags> {
    const coreResponse = await this.tryGetFeatureFlags();
    if (coreResponse !== null) {
      return this.normalizeFeatureFlags(coreResponse);
    }

    return {};
  }

  async isEnabled(flagKey: string, defaultValue = false): Promise<boolean> {
    const flags = await this.getFeatureFlags();
    if (Object.prototype.hasOwnProperty.call(flags, flagKey)) {
      return !!flags[flagKey];
    }
    return defaultValue;
  }

  private normalizeFeatureFlags(response: any): FeatureFlags {
    const normalizedFlags: FeatureFlags = {};
    if (!response || typeof response !== 'object') {
      return normalizedFlags;
    }

    const rawFlags = response.flags && typeof response.flags === 'object'
      ? response.flags
      : response;

    Object.keys(rawFlags).forEach(key => {
      if (typeof rawFlags[key] === 'boolean') {
        normalizedFlags[key] = rawFlags[key];
      }
    });

    const legacySnakeCaseKey = 'billing_mercado_pago';
    if (
      Object.prototype.hasOwnProperty.call(normalizedFlags, legacySnakeCaseKey)
      && !Object.prototype.hasOwnProperty.call(normalizedFlags, FEATURE_FLAG_KEYS.BILLING_SUBSCRIPTION_AREA)
    ) {
      normalizedFlags[FEATURE_FLAG_KEYS.BILLING_SUBSCRIPTION_AREA] = !!normalizedFlags[legacySnakeCaseKey];
    }

    return normalizedFlags;
  }

  private async tryGetFeatureFlags(): Promise<any | null> {
    try {
      return await this.get('feature-flags').toPromise();
    } catch (error) {
      return null;
    }
  }
}
